const Users = () => import('./Users.vue')

export default [
    {
        path: '/impersonate',
        name: 'impersonate',
        meta: {
            requiresAuth: true
        },
        component: Users,
    }
]